/** Internal Dependencies */
import FilerobotImageEditor from './components/AssemblyPoint';
import { TABS_IDS, TOOLS_IDS } from './utils/constants';

export { TABS_IDS as TABS, TOOLS_IDS as TOOLS };

export default FilerobotImageEditor;
